import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const CarrerListContainer = styled.div`
  display: grid;
  max-width: 1260px;
  margin: 0em auto;
  width: 100%;
  row-gap: 4rem;
`

export const JobList = styled.div`
  display: grid;
  column-gap: 1.5rem;
  row-gap: 2.75rem;
  grid-template-columns: repeat(3, 1fr);

  @media all and (max-width: ${layout.md}){
    grid-template-columns: repeat(2, 1fr);
  }
  @media all and (max-width: ${layout.md}){
    grid-template-columns: 1fr;
  }
`

export const JobListColumn = styled.div`
  display: grid;
  row-gap: 1em;
  align-self: start;
`

export const JobDepartment = styled.ul`
  list-style-type: none;
  padding: 0rem;
  margin: 0rem;

  li {
    margin: 1.5rem 0rem;
    a {
      font-size: 1.25rem;
      font-weight: 300;
      color: ${palette.text};
      text-decoration: underline;
    }
    @media all and (max-width: ${layout.md}) {
      margin: 1rem 0rem;
      a {
        font-size: 1.125rem;
      }
    }
  }
`
